import { z } from 'zod';
import { EMAIL_ERROR, REQUIRED_ERROR, inputsLength } from '@/domains/auth/constants/validation';
import { emailRegex } from '@/constants/regExp';

export const validationSchema = z.object({
  email: z
    .string({ required_error: REQUIRED_ERROR })
    .min(inputsLength.email.min, {
      message: REQUIRED_ERROR,
    })
    .regex(emailRegex, {
      message: EMAIL_ERROR,
    }),
});
